module.exports = __webpack_public_path__ + "assets/share.457909ea.svg";